export const UPDATE_CHART_NAME_REQUEST = " UPDATE_CHART_NAME_REQUEST";
export const UPDATE_CHART_NAME_SUCCESS = " UPDATE_CHART_NAME_SUCCESS";
export const UPDATE_CHART_NAME_FAILURE = " UPDATE_CHART_NAME_FAILURE";
